
import { addMoneyToUserAccount , withdrawlMoneyToUserAccount} from "../../redux/action/userActions";
import React, { useState } from 'react';
import Avatar from '@material-ui/core/Avatar';
import Button from '@material-ui/core/Button';
import CssBaseline from '@material-ui/core/CssBaseline';
import TextField from '@material-ui/core/TextField';
import Grid from '@material-ui/core/Grid';
import Box from '@material-ui/core/Box';
import CurrencyRupeeIcon from '@mui/icons-material/CurrencyRupee'; 
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';
import Container from '@material-ui/core/Container';
import { useDispatch} from 'react-redux';
import { getLocalStorage } from '../../utils/localStorage';


const useStyles = makeStyles(theme => ({
  '@global': {
    body: {
      backgroundColor: theme.palette.common.white,
    },
  },
  paper: {
    marginTop: theme.spacing(8),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: theme.palette.secondary.main,
  },
  form: {
    width: '100%', // Fix IE 11 issue.
    marginTop: theme.spacing(3),
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
}));

export const Funds = ({setOpen}) => {
    const user = getLocalStorage("user");
    const [value, setValue] = useState(0);
    const dispatch = useDispatch()
    const handleAdd = e => {
        e.preventDefault();
       dispatch(addMoneyToUserAccount({
              user, value
        }))  
        setOpen(false) 
    }
    const handleWithdrawl = e => {
        e.preventDefault();
        dispatch(withdrawlMoneyToUserAccount({
               user, value
         }))   
         setOpen(false)
     }
  const classes = useStyles();

  
  
  return (
    <Container component="main" maxWidth="xs">
      <CssBaseline />
      <div className={classes.paper} style={{ 
         backgroundColor: "white",
         border: "1px solid black",
        position: "absolute",
        width: "400px",
        top: "20%",
        padding: "30px"
    }}>
        <Avatar className={classes.avatar}>
           <CurrencyRupeeIcon />
        </Avatar>
        <Typography component="h1" variant="h5">
          Add/Withdraw Money    
             </Typography>
       <h3>Available funds: {+(user.funds).toFixed(2)}</h3>
        <form className={classes.form} noValidate>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <TextField
                autoComplete="value"
                name="value"
                variant="outlined"
                fullWidth
                id="value"
                label="Amount"
                type="Number"
                onChange={e => setValue(e.target.value)}
                autoFocus
              />
            </Grid>
          
          </Grid>
          <Button
            type="submit"
            halfwidth="true"
            variant="contained"
            color="primary"
            className={classes.submit}
           onClick={handleAdd}  
          >
           Add
          </Button> &nbsp; &nbsp;
          <Button
            type="submit"
            halfwidth="true"
            variant="contained"
            color="secondary"
            className={classes.submit}
           onClick={handleWithdrawl}  
          >
           Withdrawl
          </Button> &nbsp; &nbsp;
          <Button
       halfwidth="true"
       variant="contained"
       color="default"
       className={classes.submit}
       onClick = {()=>setOpen(false)}
     >
      Cancel
     </Button>
        </form>
      </div>
      <Box mt={5}>
      </Box>
    </Container>
  );
}